import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=8962%3A20700
 *
 * @param {SvgIconProps} props - svg props
 */
export const ContactsButtonIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M12.5626 11.7744C13.7612 11.7159 14.629 10.2397 14.5541 8.71185C14.4792 7.18397 13.4608 6.05218 12.137 6.11675C10.8131 6.18133 9.93921 7.27677 10.0141 8.80466C10.0891 10.3325 11.3641 11.8328 12.5626 11.7744ZM10.6196 11.8044C10.6867 11.7596 10.7426 11.7222 10.7881 11.7012C11.0378 12.666 11.9891 13.7782 12.9638 13.7158C13.6836 13.6696 13.9049 13.1127 13.8362 11.9195C13.9153 11.9585 13.9314 11.9988 13.9487 12.0421C13.9658 12.0846 13.984 12.1301 14.0643 12.1801C14.3443 12.3269 14.5885 12.4178 14.8038 12.498C15.5714 12.7837 15.972 12.9329 16.3214 14.9939C16.4668 15.8521 16.206 16.782 15.4397 17.1948C13.3551 18.3176 10.5559 17.428 8.61643 16.7893C7.70508 16.4892 6.99085 15.6208 7.11664 14.6695C7.23787 13.7527 7.49233 13.2225 7.89722 12.7519C8.36121 12.2125 8.94435 12.1933 9.44969 12.1767C9.53754 12.1739 9.62304 12.1711 9.70515 12.1656C10.1205 12.138 10.4195 11.9382 10.6196 11.8044Z' fill='white'/>
        </SvgIcon>
    )
}

export default ContactsButtonIcon
